'use client';

import { useEffect } from 'react';
import { speakerData } from '@/data/speaker';

export default function NerdSniped() {
  useEffect(() => {
    const art = `
%c
   _____ ___    __  _______  ___    __    ______
  / ___//   |  /  |/  / __ )/   |  / /   / ____/
  \\__ \\/ /| | / /|_/ / __  / /| | / /   / __/
 ___/ / ___ |/ /  / / /_/ / ___ |/ /___/ /___
/____/_/  |_/_/  /_/_____/_/  |_/_____/_____/

     👋 Oh hi und Guten Tag!
%c
If you're poking around in here, you already know
your way around a DevTools console. Which raises a
question: is THIS site as technically fit for SEO
and GEO (Generative Engine Optimization) as it
could be? 🤔

Turns out even keynote speaker sites need someone
who actually reads the network tab. 

Need a hand making a site as AI-search-ready as
this one is trying to be? Contact me!

📬 ${speakerData.email}
`;
    console.log(
      art,
      'color:#22d3ee;font-weight:bold;',
      'color:inherit;font-weight:normal;'
    );
  }, []);

  return null;
}
